import { Footer, Nav } from '@/components/layout';
import { Divider } from '@/components/ui';
import {
  AboutUsSection,
  ContinuousDeliverySection,
  DemoSection,
  ExploreSection,
  Hero,
  // HowItWorksSection,
  ReserveSection,
  // TiersSection,
  WhatIsSection,
} from '@/sections';

/**
 * Top-level page composition. Sections are rendered in the order from the
 * original reference, separated by art-deco dividers whose `bg` colour
 * matches the section above so the diamond glyph blends in cleanly.
 */
export function App() {
  return (
    <>
      <Nav />

      <Hero />
      <Divider bg="#0a1a2a" />

      <WhatIsSection />
      <Divider bg="#0a1a2a" />
    
      <DemoSection />
      <Divider bg="#0a1a2a" />

      <ExploreSection />
      <Divider bg="#14263b" />

      <ContinuousDeliverySection />
      <Divider bg="#0a1a2a" />

      {/*<TiersSection />
      <Divider bg="#14263b" />*/}

      {/*<HowItWorksSection />
      <Divider bg="#0a1a2a" />*/}

      <ReserveSection />
      <Divider bg="#0a1a2a" />

      <AboutUsSection />

      <Footer />
    </>
  );
}
